"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _HoverInfo = _interopRequireDefault(require("./HoverInfo/HoverInfo"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HoverInfoStyle = _styledComponents.default.div.withConfig({
  displayName: "InfoCircle__HoverInfoStyle",
  componentId: "sc-1yhe7k6-0"
})(["position:relative;", ""], function (props) {
  return props.isHover || (0, _styledComponents.css)(["display:none;"]);
});

var InfoCircle = function InfoCircle(_ref) {
  var className = _ref.className,
      hoverInfoDescriptions = _ref.hoverInfoDescriptions;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isHover = _useState2[0],
      setIsHover = _useState2[1];

  return /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    onMouseOver: function onMouseOver() {
      return setIsHover(true);
    },
    onMouseOut: function onMouseOut() {
      return setIsHover(false);
    }
  }, /*#__PURE__*/_react.default.createElement(HoverInfoStyle, {
    isHover: isHover
  }, /*#__PURE__*/_react.default.createElement(_HoverInfo.default, {
    hoverInfoDescriptions: hoverInfoDescriptions
  })), /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faInfoCircle
  }));
};

InfoCircle.propTypes = {
  className: _propTypes.default.string,
  hoverInfoDescriptions: _propTypes.default.string
};

var _default = (0, _styledComponents.default)(InfoCircle).withConfig({
  displayName: "InfoCircle",
  componentId: "sc-1yhe7k6-1"
})(["font-size:14px;float:right;"]);

exports.default = _default;